import {useQuery} from "@tanstack/react-query";
import {
    PromoToken,
    PromoTokensApi,
} from "@devour/client";

async function fetchPromoToken(guildId: string): Promise<PromoToken> {
    return await new PromoTokensApi().getPromoTokensId({
        id: guildId,
    });
}

function getPromoTokenQuery(promoTokenId: string) {
    return {
        queryKey: [
            "get-promo-token", promoTokenId,
        ],
        queryFn: () => fetchPromoToken(promoTokenId),
        staleTime: 60000,
        enabled: !!promoTokenId,
    } as const;
}

export function useGetPromoToken(promoTokenId: string) {
    return useQuery(getPromoTokenQuery(promoTokenId));
}
